import { Paper, Stack, Text } from '@cowbell/ui';
import { faBrain, faSliders } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UserMemorySection from '../../components/memory/UserMemorySection';
import { PaneHeader } from './PaneHeader';
import { StudioCard } from './StudioCard';
import { TonesCard } from './TonesCard';
import styles from './PersonalizationPane.module.css';
import type_ from './settingsType.module.css';

/**
 * How Moo behaves for this user: what it remembers, and how it writes.
 *
 * Memory and Tones are stacked as cards in one pane rather than separate nav
 * items — both are personalization, and the reference groups them the same way.
 */
export function PersonalizationPane({
  onNavigate,
  onOpenApps,
}: {
  readonly onNavigate?: (path: string) => void;
  readonly onOpenApps?: () => void;
}) {
  return (
    <Stack gap="md">
      <PaneHeader
        icon={faSliders}
        title="Personalization"
        subtitle="Shape what Moo remembers about you and how it writes back."
      />

      <StudioCard onNavigate={onNavigate} onOpenApps={onOpenApps} />

      <Paper
        withBorder
        // Same treatment as the Tones card: both sit on the tinted
        // surface so each reads as its own panel against the plain pane.
        // Set via the prop because Paper's own background wins over a class.
        bg="var(--mantine-color-default-hover)"
        className={styles.card}
      >
        <div>
          <div className={styles.titleRow}>
            <FontAwesomeIcon icon={faBrain} className={styles.titleIcon} />
            <Text className={type_.cardTitle}>Memory</Text>
          </div>
          <Text className={type_.subtitle}>
            Facts Moo keeps about your work so it can personalise its answers.
          </Text>
        </div>
        <UserMemorySection />
      </Paper>

      <TonesCard />
    </Stack>
  );
}
